module.exports = __webpack_public_path__ + "img/gal-4.5dc15365.jpg";